<nz-card [nzTitle]="'protocol.title' | translate">
	<ng-template #loading>
		<nz-spin nzSimple></nz-spin>
	</ng-template>
	<app-timeline *ngIf="entries$ | async as entries; else: loading" [entries]="entries" [visibleFields]="['workflow-item']"></app-timeline>
</nz-card>